import { merge } from 'ts-deepmerge';
import { Param } from '../model/params.model';

// All this types comes from ts-deepmerge declaration
type TAllKeys<T> = T extends Param ? keyof T : never;
type TIndexValue<T, K extends PropertyKey, D = never> = T extends Param ? K extends keyof T ? T[K] : D : never;
type TPartialKeys<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>> extends infer O ? {
    [P in keyof O]: O[P];
} : never;
type TFunction = (...a: Array<Param>) => Param;
type TPrimitives = string | number | boolean | bigint | symbol | Date | TFunction;
type TMerged<T> = [T] extends [Array<Param>] ? {
    [K in keyof T]: TMerged<T[K]>;
} : [T] extends [TPrimitives] ? T : [T] extends [object] ? TPartialKeys<{
    [K in TAllKeys<T>]: TMerged<TIndexValue<T, K>>;
}, never> : T;
interface IObject {
    [key: string]: Param;
}

export class SpreadRecursive {
    static clone<T extends Array<IObject>>(...sources: T): T[number] {
        return this.merge({}, ...sources);
    }

    static cloneArray<T extends IObject>(sources: Array<T>): Array<T> {
        return sources.map(source => this.clone(source));
    }

    static merge<T extends Array<IObject>>(...objects: T): TMerged<T[number]> {
        return merge(...objects);
    }
}
